import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';

export class DaysToRelease extends Field {
  static attributesForModel() {
    return ['daysToRelease'];
  }

  get title() {
    return 'Days to release';
  }

  exampleContents(): FieldContentsData {
    return { text: 13 };
  }

  contentsForRecord(record): FieldContentsData {
    if (typeof record.daysToRelease === 'number') {
      return { text: record.daysToRelease };
    }

    return {};
  }
}
